var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3224_12578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.91406 6.59375H1.01562V19.5002H4.91406V6.59375Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88281 0.5C1.44531 0.5 0.5 1.46172 0.5 2.73862C0.5 3.99128 1.41406 4.97724 2.82813 4.97724H2.85937C4.32812 4.97724 5.24219 3.9832 5.23438 2.73862C5.20313 1.46172 4.32031 0.5 2.88281 0.5Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 6.47217C13.3281 6.47217 11.9297 7.73291 11.6719 8.62189V6.59339H7.28906C7.34375 7.66825 7.28906 19.4998 7.28906 19.4998H11.6719V12.5253C11.6719 12.1293 11.6563 11.7414 11.7656 11.4666C12.0625 10.6908 12.7109 9.88263 13.875 9.88263C15.3984 9.88263 16.0859 11.0787 16.0859 12.8244V19.4998H20.5078V12.3233C20.5078 8.33095 18.3359 6.47217 15.5625 6.47217Z",
    fill: "white",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3224_12578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinWhite);
export default __webpack_public_path__ + "static/media/linkedin-white.be43618ee1422b2165ebf6d70751669a.svg";
export { ForwardRef as ReactComponent };